import {
    // RESET_GLOBAL_DATALAYER,
    // SET_GLOBAL_DATALAYER,
    SET_AUTH_STATUS,
    SET_ACCESS_TOKEN,
    SET_FOOTER_DATA,
    AUTH_COOKIE_STORE,
  } from '../constant';

  import Cookies from 'js-cookie';
  import { getCookie } from '../../utils/AEMUtils';
  import { REFRESH_TOKEN_URL } from '../constant/app.properties';
  import { invokeService } from '../../service';
  // export const resetGlobalDataLayer = () => ({
  //   type: RESET_GLOBAL_DATALAYER,
  // });
  
  // export const setGlobalDataLayer = (res) => ({
  //   type: SET_GLOBAL_DATALAYER,
  //   payload:res
  // });

  export const setAuthStatus= (customerRes) => ({
    type: SET_AUTH_STATUS,
    payload:customerRes
  });

  export const  setAccessToken= (res) => ({
    type: SET_ACCESS_TOKEN,
    payload:res
  });

  export const  setFooterData= (res) => ({
    type: SET_FOOTER_DATA,
    payload:res
  });

 /*  export function  ClearDateCalenderSelection (btnType,res){
    if(btnType === "checkInBtn")
    return{
      type: CLEAR_CHECKIN_DATE,
      payload:res
    }
    else if(btnType === "checkOutBtn"){
      return{
        type: CLEAR_CHECKOUT_DATE,
        payload:res
      }
     
    }
    
  }; */


  export const fetchRefreshToken = async (isRetry, originalResolve,
    originalReject) => new Promise(async (resolve, reject) => {
    const url = REFRESH_TOKEN_URL;
    const customerDetails = JSON.parse(localStorage.getItem('_customerDetails'));
    const { subscriberId } = customerDetails;
    const customURL = `${url}?customerIdQ=${subscriberId}&appType=rcio`;
  
    const response = await invokeService({
      resource: customURL,
      method: 'POST',
    });
  
    if (!isRetry) {
      if (response.status === 200 && response && response.data && response.data.refresh_token_status === 'approved') {
        resolve(response);
        const loggedIn = JSON.parse(getCookie(AUTH_COOKIE_STORE));
        const expiresIn = new Date(new Date().getTime() + loggedIn?.refresh_token_expires_in * 1000);
        Cookies.set(AUTH_COOKIE_STORE, loggedIn, { expires: expiresIn });
      } else {
        fetchRefreshToken(true, resolve, reject);
      }
    } else {
      if (response.status === 200 && response && response.data && response.data.refresh_token_status === 'approved') {
        originalResolve(response);
      } else {
        typeof originalReject === 'function' ? originalReject(response) : reject(response);
      }
    }
  });
  

export const updateDashboardDetails = (data)  => async (dispatch) => dispatch({ type: 'UPDATE_DASHBOARD_DETAILS', payload: data });
  
  
  export * from './LogErrorMessage';
  export * from './MessageCatalog';
  export * from './Trip';
  /*  export * from './HeaderFooterAction'; */
  export * from './BalanceAction'; 
  export * from './Favorite';
  export * from './GalleryVideoAction';
 


  

  